$( function () {
	function fallbackCopy( text ) {
		const input = document.createElement( 'input' );
		input.value = text;
		input.style.position = 'fixed';
		input.style.opacity = '0';
		document.body.appendChild( input );
		input.select();
		document.execCommand( 'copy' );
		document.body.removeChild( input );
	}

	$( document ).on( 'click', '[data-copy-link]', function () {
		const btn = this;
		const url = $( btn ).attr( 'data-copy-link' );

		// navigator.clipboard needs a secure context (https/localhost) - falls
		// back to the old execCommand trick over plain http (e.g. local dev).
		const copy = ( navigator.clipboard && window.isSecureContext )
			? navigator.clipboard.writeText( url )
			: Promise.resolve( fallbackCopy( url ) );

		copy.then( function () {
			const original = btn.innerHTML;
			btn.innerHTML = '<i class="fa-light fa-check"></i> Link kopiran';
			setTimeout( function () {
				btn.innerHTML = original;
			}, 1500 );
		} );
	} );
} );
